const CloseSearch = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            width="23"
            height="23"
            viewBox="0 0 23 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M1.5 21.5L21.5 1.5M21.5 21.5L1.5 1.5"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
            />
        </svg>
    )
}

export default CloseSearch
